export default __webpack_public_path__ + "static/media/on-error-icon.586d03ab.svg";